import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack } from 'src/core/ui';
import { useUserCanFulfillSale } from 'src/hooks/useUserHasSalePermissions';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchBulkUpdateBarcodes = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const hasFulfillPermission = useUserCanFulfillSale(
    undefined /* sale */,
    true /* forBulkEdit */
  );

  if (!hasFulfillPermission) {
    return null;
  }

  return (
    <>
      <PosDropdownItem
        key="BulkUpdateBarcodes"
        onClick={onClick}
        disabled={disabled}
      >
        <Stack gap="m" alignItems="center" width="full">
          <span style={{ textAlign: 'left' }}>
            <Content id={ContentId.UploadBarcodes} />
          </span>
        </Stack>
      </PosDropdownItem>
    </>
  );
};
